import { render } from "./ResultsComponent.vue?vue&type=template&id=791bfc59&scoped=true"
import script from "./ResultsComponent.vue?vue&type=script&lang=js"
export * from "./ResultsComponent.vue?vue&type=script&lang=js"

import "./ResultsComponent.vue?vue&type=style&index=0&id=791bfc59&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791bfc59"]])

export default __exports__